import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import CheckEmail from './CheckEmail';
import HasBeenReset from './HasBeenRest';

export {
  ForgotPassword,
  ResetPassword,
  CheckEmail,
  HasBeenReset
};



// WEBPACK FOOTER //
// ./src/views/Auth/index.js